export const TRANSITIONING_COHORT = 'cohort3' as const;
export const EMPTY_STATE_TRANSITIONING_COHORT = 'cohort3.5' as const;
